module.exports = __webpack_public_path__ + "img/technical_support.5cb67682.jpg";